<template>
  <div class="flex items-start gap-3 flex-1">
    <UiAvatar 
      :url="profilePicture ?? undefined" 
      :initials="generateInitials(name)" 
      size="sm" 
    />
    <div class="flex-1 min-w-0">
      <UiText as="p" class="font-semibold" :text="name" />
      <UiText v-if="role" as="p" variant="p-small" class="text-gray-600" :text="role" />
      <UiText as="p" variant="p-small" :text="expertTypeLabel" />
      <UiText v-if="projectName" as="p" variant="p-small" :text="`Project: ${projectName}`" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { UiText, UiAvatar, generateInitials } from '@shopexperts/shared';

const props = defineProps<{
  name: string;
  profilePicture?: string | null;
  expertType: 'freelancer' | 'agency';
  role?: string;
  projectName?: string | null;
}>();

const expertTypeLabel = computed(() => {
  return props.expertType === 'freelancer' ? 'Freelancer' : 'Agency';
});
</script>

